import { useCallback, useEffect, useRef, useState } from 'react';
import { CheckCircle2, X, XCircle } from 'lucide-react';

export function useTeamNotice() {
  const [notice, setNotice] = useState(null);
  const timerRef = useRef(null);

  const dismiss = useCallback(() => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = null;
    setNotice(null);
  }, []);

  const showNotice = useCallback((message, type = 'success') => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    setNotice({ message, type });
    timerRef.current = window.setTimeout(() => {
      timerRef.current = null;
      setNotice(null);
    }, 2600);
  }, []);

  useEffect(() => () => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
  }, []);

  return { notice, showNotice, dismiss };
}

export default function TeamNotice({ notice, onClose }) {
  if (!notice) return null;
  const error = notice.type === 'error';

  return (
    <div
      className={`team-toast team-toast--${error ? 'error' : 'success'}`}
      role={error ? 'alert' : 'status'}
      aria-live={error ? 'assertive' : 'polite'}
    >
      {error ? <XCircle size={16} /> : <CheckCircle2 size={16} />}
      <span>{notice.message}</span>
      <button type="button" aria-label="关闭提示" onClick={onClose}><X size={13} /></button>
    </div>
  );
}
